import React from "react";
import { useTranslation } from "react-i18next";
import { FaFacebookF, FaInstagram, FaTiktok, FaYoutube } from "react-icons/fa";
import "./footer.css";

const Footer = () => {
  const { t } = useTranslation();

  const year = new Date().getFullYear();

  return (
    <footer>
      <ul className="permalinks">
        <li>
          <a href="/#">{t("footer.home")}</a>
        </li>
        <li>
          <a href="#about">{t("footer.about")}</a>
        </li>
        <li>
          <a href="#experience">{t("footer.experience")}</a>
        </li>
        <li>
          <a href="#services">{t("footer.services")}</a>
        </li>
        <li>
          <a href="#portfolio">{t("footer.portfolio")}</a>
        </li>
        <li>
          <a href="#testimonials">{t("footer.testimonials")}</a>
        </li>
        <li>
          <a href="#contact">{t("footer.contact")}</a>
        </li>
      </ul>

      <div className="footer__socials">
        <a
          href="https://facebook.com/enderson.marin.9"
          target="_blank"
          rel="noreferrer"
        >
          <FaFacebookF />
        </a>
        <a
          href="https://instagram.com/marinenderson"
          target="_blank"
          rel="noreferrer"
        >
          <FaInstagram />
        </a>
        <a
          href="https://www.tiktok.com/@endersondev"
          target="_blank"
          rel="noreferrer"
        >
          <FaTiktok />
        </a>
        <a
          href="https://www.youtube.com/@millanendersondev"
          target="_blank"
          rel="noreferrer"
        >
          <FaYoutube />
        </a>
      </div>

      <div className="footer__copyright">
        <small>
          &copy; Eng. Enderson Millan {year}. {t("footer.rights")}
        </small>
      </div>
    </footer>
  );
};

export default Footer;
